/**
 * Major Arcana — 22 ใบ สำหรับคำทำนายภาษาไทย
 * เลขนำโชคอิงตามเลขไพ่ + นumerology ดั้งเดิม
 */
export const MAJOR_ARCANA = [
  {
    id: 0, number: 0, nameEn: 'The Fool', nameTh: 'คนโง่', symbol: '☆',
    element: 'ลม', planet: 'ดาวยูเรนัส',
    keywords: ['เริ่มต้นใหม่', 'กล้าเสี่ยง', 'เชื่อมั่น'],
    upright: 'จุดเริ่มต้นของการเดินทางใหม่ จิตใจเปิดรับและกล้าที่จะก้าวออกจาก comfort zone แม้ยังไม่เห็นทางชัดเจนทุกอย่าง',
    love: 'ความสัมพันธ์ใหม่หรือการเริ่มต้นด้วยใจบริสุทธิ์ ปล่อยวางความกลัวแล้วเปิดรับคนใหม่',
    work: 'โปรเจกต์หรืออาชีพใหม่ที่ต้องใช้ความกล้า โอกาสมาจากการลองสิ่งที่ไม่เคยทำ',
    money: 'รายได้จากทางที่ไม่คาดคิด แต่ควรวางแผนก่อนใช้จ่ายตามอารมณ์',
    health: 'พลังงานสดใส ควรออกกำลังกายเบาๆ และพักผ่อนให้สมดุล',
    advice: 'ก้าวแรกสำคัญที่สุด — ลงมือทำด้วยหัวใจที่สดใส แต่ยังต้องมีสติ',
    dreamKeyword: 'เริ่มต้นใหม่',
    luckyDigits: ['00', '22', '69'],
  },
  {
    id: 1, number: 1, nameEn: 'The Magician', nameTh: 'นักมายากล', symbol: '∞',
    element: 'ลม', planet: 'ดาวพุธ',
    keywords: ['พลังสร้างสรรค์', 'ทักษะ', 'จุดประสงค์'],
    upright: 'คุณมีทรัพยากรครบในมือแล้ว — ความสามารถ ไอเดีย และโอกาสพร้อมให้คุณเปลี่ยนความคิดเป็นจริง',
    love: 'ความดึงดูดสูง คุณสามารถสื่อสารความรู้สึกได้ชัดเจนและสร้างความสัมพันธ์ที่ตรงใจ',
    work: 'ช่วง peak ของการแสดงศักยภาพ นำเสนอไอเดีย ปิดดีล หรือเริ่มธุรกิจได้ดี',
    money: 'รายได้จากความสามารถเฉพาะตัว ลงทุนในตัวเองแล้วผลตอบแทนดี',
    health: 'จิตใจแข็งแรง ควบคุมนิสัยได้ดี เหมาะเริ่มนิสัวใหม่เพื่อสุขภาพ',
    advice: 'มุ่งเน้นสิ่งเดียวแล้วลงมือทำเต็มที่ — พลังของคุณอยู่ที่จุดนี้',
    dreamKeyword: 'นักมายากล',
    luckyDigits: ['01', '10', '19'],
  },
  {
    id: 2, number: 2, nameEn: 'The High Priestess', nameTh: 'นักบวชหญิง', symbol: '☽',
    element: 'น้ำ', planet: 'ดวงจันทร์',
    keywords: ['สัญชาตญาณ', 'ความลับ', 'จิตใต้สำนึก'],
    upright: 'เวลาแห่งการฟังเสียงภายใน สิ่งที่มองไม่เห็นสำคัญกว่าสิ่งที่เห็น ความจริงซ่อนอยู่ใต้ผิวเผิน',
    love: 'ความรู้สึกลึกซึ้งแต่อาจยังไม่พูดออก รอให้เวลาช่วยเปิดเผยความจริง',
    work: 'ศึกษา วิจัย หรือวางแผนลับๆ ก่อนลงมือ — อย่ารีบเปิดเผยทุกอย่าง',
    money: 'เก็บออมและรอจังหวะ การลงทุนระยะยาวดีกว่าเสี่ยงเร็ว',
    health: 'พักผ่อน นอนหลับ ดูแลจิตใจ ฝันอาจสื่อข้อความสำคัญ',
    advice: 'หยุดฟังคนอื่นมากเกินไป แล้วถามใจตัวเองว่าอะไรคือคำตอบ',
    dreamKeyword: 'น้ำท่วม',
    luckyDigits: ['02', '20', '11'],
  },
  {
    id: 3, number: 3, nameEn: 'The Empress', nameTh: 'จักรพรรดินี', symbol: '♀',
    element: 'ดิน', planet: 'ดาวศุกร์',
    keywords: ['ความอุดมสมบูรณ์', 'ความงาม', 'การเจริญเติบโต'],
    upright: 'ช่วงแห่งการเติบโต ผลิตผล และความอุดมสมบูรณ์ ธรรมชาติและความรักหล่อเลี้ยงสิ่งที่คุณปลูกฝัง',
    love: 'ความรักอบอุ่น ครอบครัว หรือการตั้งครรภ์ ความสัมพันธ์เบ่งบาน',
    work: 'ผลงานออกดอกออกผล ธุรกิจขยายตัว ความร่วมมือราบรื่น',
    money: 'รายได้เพิ่ม โชคลาภจากความงามหรือสิ่งสร้างสรรค์',
    health: 'สุขภาพดี ร่างกายฟื้นตัว ดูแลตัวเองและคนรอบข้าง',
    advice: 'ดูแลสิ่งที่คุณรักและให้เวลามันเติบโต — ผลลัพธ์จะมาอย่างหนักแน่น',
    dreamKeyword: 'ทอง',
    luckyDigits: ['03', '30', '12'],
  },
  {
    id: 4, number: 4, nameEn: 'The Emperor', nameTh: 'จักรพรรดิ', symbol: '♔',
    element: 'ไฟ', planet: 'ดาวอังคาร',
    keywords: ['อำนาจ', 'โครงสร้าง', 'ความมั่นคง'],
    upright: 'ต้องยึดโครงสร้าง วินัย และความรับผิดชอบ ผู้นำหรือบิดา/ผู้ปกครองมีบทบาทสำคัญ',
    love: 'ความมุ่งมั่นในความสัมพันธ์ อาจดูจริงจังแต่ให้ความมั่นคง',
    work: 'ขึ้นเป็นผู้นำ กำหนดกฎ ควบคุมโปรเจกต์ — สำเร็จด้วยวินัย',
    money: 'การเงินมั่นคง ลงทุนระยะยาว อสังหาริมทรัพย์หรือสินทรัพย์ถาวรดี',
    health: 'แข็งแรง แต่ระวังเครียดสะสมจากการควบคุมมากเกินไป',
    advice: 'ตั้งกติกาให้ชัด แล้วยึดมั่น — ความมั่นคงมาจากวินัย',
    dreamKeyword: 'ช้าง',
    luckyDigits: ['04', '40', '13'],
  },
  {
    id: 5, number: 5, nameEn: 'The Hierophant', nameTh: 'พระสันตะปาปา', symbol: '✝',
    element: 'ดิน', planet: 'ดาวพฤหัสบดี',
    keywords: ['ประเพณี', 'ความเชื่อ', 'คำสอน'],
    upright: 'เรียนรู้จากผู้รู้ ประเพณี หรือระบบที่พิสูจน์แล้ว ความเชื่อและศรัทธานำทาง',
    love: 'ความสัมพันธ์จริงจัง แต่งงาน หรือได้รับคำอวยพรจากครอบครัว',
    work: 'เรียนรู้จาก mentor ทำตามขั้นตอนมาตรฐาน ได้รับการยอมรับ',
    money: 'รายได้จากองค์กรหรืออาชีพดั้งเดิม เก็บออมตามหลักสอน',
    health: 'ดูแลร่างกายตามหลักวินัย สวดมนต์หรือสมาธิช่วยได้',
    advice: 'หาแนวทางที่คนที่คุณเคารพยืนยันแล้ว — อย่าต่อต้านทุกอย่าง',
    dreamKeyword: 'ฝันเห็นพระ',
    luckyDigits: ['05', '50', '14'],
  },
  {
    id: 6, number: 6, nameEn: 'The Lovers', nameTh: 'คนรัก', symbol: '♡',
    element: 'ลม', planet: 'ดาวศุกร์',
    keywords: ['ทางเลือก', 'ความรัก', 'ความสามัคคี'],
    upright: 'ทางเลือกสำคัญที่หัวใจมีส่วน — ความรัก ความสัมพันธ์ หรือค่านิยมที่ต้องตัดสินใจ',
    love: 'ความรักลึกซึ้ง คู่แท้ หรือต้องเลือกระหว่างสองทาง',
    work: 'หุ้นส่วนหรือทีมที่เข้ากันได้ดี ตัดสินใจร่วมกัน',
    money: 'รายได้จากความร่วมมือ แบ่งปันผลกำไร',
    health: 'สมดุลกายใจ ความสัมพันธ์ดีช่วยฟื้นพลัง',
    advice: 'เลือกสิ่งที่หัวใจและเหตุผลเห็นพ้องกัน — ไม่มีทางเลือกที่สมบูรณ์แบบ',
    dreamKeyword: 'แหวน',
    luckyDigits: ['06', '60', '15'],
  },
  {
    id: 7, number: 7, nameEn: 'The Chariot', nameTh: 'รถม้า', symbol: '⚡',
    element: 'น้ำ', planet: 'ดาวจันทร์',
    keywords: ['ชัยชนะ', 'มุ่งมั่น', 'การควบคุม'],
    upright: 'ชัยชนะมาจากความมุ่งมั่นและการควบคุมอารมณ์สองด้านที่ดึงไปคนละทาง',
    love: 'ไล่ตามคนที่ชอบหรือพิชิตใจได้ แต่ต้องไม่บังคับเกินไป',
    work: 'ชนะการแข่งขัน ย้ายงาน หรือเดินทางเพื่อธุรกิจสำเร็จ',
    money: 'รายได้จากความพยายาม โบนัสหรือรางวัล',
    health: 'พลังสูง แต่ระวังอุบัติเหตุจากการรีบ',
    advice: 'ตั้งเป้าแล้วขับเคลื่อนไป — อารมณ์สองข้างต้องถูกนำทาง',
    dreamKeyword: 'รถ',
    luckyDigits: ['07', '70', '16'],
  },
  {
    id: 8, number: 8, nameEn: 'Strength', nameTh: 'พลัง', symbol: '∞',
    element: 'ไฟ', planet: 'ดาวพฤหัสบดี',
    keywords: ['ความอดทน', 'ความกล้า', 'ควบคุมตนเอง'],
    upright: 'พลังแท้ไม่ใช่การบังคับ แต่คือความอ่อนโยนและความอดทนที่ควบคุมสัญชาตญาณ',
    love: 'ความรักที่อดทน ให้อภัย และเข้าใจกันลึกซึ้ง',
    work: 'ผ่านวิกฤตด้วยความนิ่ง ไม่ยอมแพ้แม้กดดันสูง',
    money: 'รายได้ค่อยๆ เพิ่ม อดทนรอผล',
    health: 'ฟื้นตัวจากความเจ็บป่วย สติแข็งแรง',
    advice: 'ใช้หัวใจนำสัญชาตญาณ — อ่อนโยนแต่ไม่อ่อนแอ',
    dreamKeyword: 'สิงโต',
    luckyDigits: ['08', '80', '17'],
  },
  {
    id: 9, number: 9, nameEn: 'The Hermit', nameTh: 'ฤาษี', symbol: '☀',
    element: 'ดิน', planet: 'ดาวพุธ',
    keywords: ['ความสงบ', 'การค้นหา', 'ภูมิปัญญา'],
    upright: 'ถอยห่างเพื่อมองภาพรวม คำตอบอยู่ภายใน ไม่ใช่จากภายนอก',
    love: 'ช่วงโสดหรือต้องการพื้นที่ ความสัมพันธ์ต้องการความเข้าใจลึกซึ้ง',
    work: 'ทำงานคนเดียว วิจัย หรือวางแผนระยะยาว',
    money: 'ประหยัด ลงทุนอย่างรอบคอบ ไม่ฟุ่มเฟือย',
    health: 'พักผ่อน สมาธิ ลดสิ่งเร้ารบกวน',
    advice: 'หยุดพักแล้วถามตัวเอง — แสงสว่างอยู่ในมือคุณ',
    dreamKeyword: 'ฤาษี',
    luckyDigits: ['09', '90', '18'],
  },
  {
    id: 10, number: 10, nameEn: 'Wheel of Fortune', nameTh: 'กงล้อแห่งโชคชะตา', symbol: '☸',
    element: 'ไฟ', planet: 'ดาวพฤหัสบดี',
    keywords: ['จังหวะชีวิต', 'โชคชะตา', 'การเปลี่ยนแปลง'],
    upright: 'จุดเปลี่ยนสำคัญ — โชคหมุนเวียน สิ่งที่ขึ้นอยู่กับจังหวะมากกว่าความพยายาม',
    love: 'พบคนใหม่โดยบังเอิญ หรือความสัมพันธ์เปลี่ยนทิศทาง',
    work: 'โอกาสใหม่ ย้ายทีม หรือ twist ที่ไม่คาดคิด',
    money: 'โชคลาภ หวย หรือรายได้กระโดด — ใช้โอกาสให้ทัน',
    health: 'สุขภาพเปลี่ยนแปลง ดีขึ้นหรือต้องระวังตามจังหวะ',
    advice: 'จับจังหวะให้ได้ — โชคมาแล้วต้องรับ',
    dreamKeyword: 'กงล้อ',
    luckyDigits: ['10', '01', '55'],
  },
  {
    id: 11, number: 11, nameEn: 'Justice', nameTh: 'ความยุติธรรม', symbol: '⚖',
    element: 'ลม', planet: 'ดาวศุกร์',
    keywords: ['ความยุติธรรม', 'สมดุล', 'ผลของกรรม'],
    upright: 'ทุกการกระทำมีผล — ได้รับสิ่งที่สมควร ตัดสินใจด้วยเหตุผลและความยุติธรรม',
    love: 'ความสัมพันธ์ต้องซื่อสัตย์ หรือได้รับความยุติธรรมในคดีความ',
    work: 'สัญญา กฎหมาย หรือการตัดสินที่เป็นธรรม',
    money: 'หนี้สินชัดเจน ได้คืนหรือเสียตามสมควร',
    health: 'สมดุลกายใจ รักษาตามหลักวิทยาศาสตร์',
    advice: 'ทำในสิ่งที่ถูกต้อง — ผลจะยุติธรรม',
    dreamKeyword: 'ตุลย์',
    luckyDigits: ['11', '29', '38'],
  },
  {
    id: 12, number: 12, nameEn: 'The Hanged Man', nameTh: 'คนถูกแขวน', symbol: '△',
    element: 'น้ำ', planet: 'ดาวเนปจูน',
    keywords: ['การเสียสละ', 'มุมมองใหม่', 'หยุดรอ'],
    upright: 'หยุดต่อสู้แล้วปล่อยวาง มุมมองใหม่เกิดจากการยอมรับสถานการณ์',
    love: 'รอคนรัก หรือความสัมพันธ์ที่ต้องอดทน',
    work: 'ชะลอโปรเจกต์ เปลี่ยนมุมมอง หรือเสียสละระยะสั้นเพื่อระยะยาว',
    money: 'รายได้ชะลอ อย่ารีบลงทุน',
    health: 'พักฟื้น โยคะ หรือการปลดปล่อยความตึงเครียด',
    advice: 'ยอมหยุดก่อน — คำตอบมาเมื่อคุณปล่อยวาง',
    dreamKeyword: 'แขวนคอ',
    luckyDigits: ['12', '21', '39'],
  },
  {
    id: 13, number: 13, nameEn: 'Death', nameTh: 'ความตาย', symbol: '☠',
    element: 'น้ำ', planet: 'ดาวพลูโต',
    keywords: ['การเปลี่ยนแปลง', 'จบวัฏจักร', 'การเกิดใหม่'],
    upright: 'จบสิ่งเก่าเพื่อเริ่มใหม่ — ไม่ใช่ความตายตัว แต่คือการ transform อย่างสมบูรณ์',
    love: 'จบความสัมพันธ์เก่า หรือเปลี่ยนรูปแบบความรัก',
    work: 'เปลี่ยนงาน ยุติโปรเจกต์ หรือ rebrand',
    money: 'ตัดขาดทุน เปลี่ยนพอร์ต — เจ็บแต่จำเป็น',
    health: 'เลิกนิสัยเสีย ฟื้นหลังพักฟื้น',
    advice: 'ปล่อยของเก่า — พื้นที่ว่างรับสิ่งใหม่',
    dreamKeyword: 'คนตาย',
    luckyDigits: ['13', '31', '49'],
  },
  {
    id: 14, number: 14, nameEn: 'Temperance', nameTh: 'ความพอประมาณ', symbol: '△',
    element: 'ไฟ', planet: 'ดาวศุกร์',
    keywords: ['สมดุล', 'การรวมกัน', 'ความอดทน'],
    upright: 'ผสมผสานสิ่งตรงข้ามให้กลมกลืน ความอดทนและความพอดีนำไปสู่ความสำเร็จ',
    love: 'ความสัมพันธ์สมดุล ประนีประนอม หรือ healing',
    work: 'ทำงานร่วมกันข้ามทีม ผสมไอเดีย',
    money: 'รายได้สม่ำเสมอ ลงทุนสมดุล',
    health: 'ฟื้นสมดุล อาหารและน้ำสำคัญ',
    advice: 'อย่าสุดโต่ง — ทางสายกลางคือคำตอบ',
    dreamKeyword: 'น้ำใส',
    luckyDigits: ['14', '41', '23'],
  },
  {
    id: 15, number: 15, nameEn: 'The Devil', nameTh: 'ปีศาจ', symbol: '☤',
    element: 'ดิน', planet: 'ดาวเสาร์',
    keywords: ['พันธนาการ', 'ความหลง', 'กามารมณ์'],
    upright: 'ติดอยู่กับความหลง นิสัยเสีย หรือความกลัว — โซ่ถอดได้ถ้าตระหนัก',
    love: 'ความหลงใหล ความสัมพันธ์ toxic หรือ jealousy',
    work: 'ทำงานเพราะเงินอย่างเดียว หรือติดระบบที่ไม่ชอบ',
    money: 'หนี้ การพนัน หรือใช้จ่ายตามใจ',
    health: 'นิสัยเสียต่อสุขภาพ ต้องตระหนักรู้',
    advice: 'มองความหลงตรงๆ — คุณเลือกปลดโซ่ได้',
    dreamKeyword: 'ปีศาจ',
    luckyDigits: ['15', '51', '33'],
  },
  {
    id: 16, number: 16, nameEn: 'The Tower', nameTh: 'หอคอย', symbol: '⚡',
    element: 'ไฟ', planet: 'ดาวอังคาร',
    keywords: ['การพังทลาย', 'ปฏิวัติ', 'ความจริง'],
    upright: 'โครงสร้างเท็จพังทลาย — เจ็บปวดแต่เปิดทางสู่ความจริง',
    love: 'เลิกกะทันหัน หรือเปิดเผยความลับที่เปลี่ยนทุกอย่าง',
    work: 'วิกฤต ไล่ออก หรือบริษัทล้ม — ต้องสร้างใหม่',
    money: 'ขาดทุนกะทันหัน อย่าเสี่ยงตอนนี้',
    health: 'ระวังอุบัติเหตุ สติสำคัญ',
    advice: 'ยอมรับการพังทลาย — สิ่งที่แท้จริงเหลืออยู่',
    dreamKeyword: 'ไฟไหม้',
    luckyDigits: ['16', '61', '34'],
  },
  {
    id: 17, number: 17, nameEn: 'The Star', nameTh: 'ดาว', symbol: '✦',
    element: 'ลม', planet: 'ดาวยูเรนัส',
    keywords: ['ความหวัง', 'การฟื้นฟู', 'แรงบันดาลใจ'],
    upright: 'หลังพายุมาถึงความหวัง จิตใจฟื้น มีแสงนำทางและพลังบวก',
    love: 'ความรักใหม่ที่สดใส หรือ healing หลังเลิก',
    work: 'โปรเจกต์ใหม่ที่สร้างแรงบันดาลใจ ได้รับการยอมรับ',
    money: 'รายได้ค่อยๆ ดีขึ้น โชคลาภระยะยาว',
    health: 'ฟื้นตัว สุขภาพดีขึ้นชัดเจน',
    advice: 'เชื่อในความหวัง — จักรวาลสนับสนุนคุณ',
    dreamKeyword: 'ดาว',
    luckyDigits: ['17', '71', '26'],
  },
  {
    id: 18, number: 18, nameEn: 'The Moon', nameTh: 'พระจันทร์', symbol: '☽',
    element: 'น้ำ', planet: 'ดวงจันทร์',
    keywords: ['ความลับ', 'ความกลัว', 'จิตใต้สำนึก'],
    upright: 'สิ่งไม่ชัดเจน ความกลัวและภาพลวงตา — ฝันและสัญชาตญาณสำคัญแต่ต้องแยกจริงเท็จ',
    love: 'ความสัมพันธ์คลุมเครือ หรือความรู้สึกที่ยังไม่ชัด',
    work: 'ข้อมูลไม่ครบ อย่าตัดสินใจเร็ว',
    money: 'หลอกลวงหรือความเสี่ยงซ่อนอยู่ — ตรวจสอบให้ดี',
    health: 'นอนไม่หลับ ความวิตก — ดูแลจิตใจ',
    advice: 'รอให้หมอกจาง — อย่าเชื่อทุกสิ่งที่เห็น',
    dreamKeyword: 'พระจันทร์',
    luckyDigits: ['18', '81', '27'],
  },
  {
    id: 19, number: 19, nameEn: 'The Sun', nameTh: 'พระอาทิตย์', symbol: '☀',
    element: 'ไฟ', planet: 'ดวงอาทิตย์',
    keywords: ['ความสุข', 'ความสำเร็จ', 'พลังบวก'],
    upright: 'ช่วงรุ่งอรุณ — ความสุข ความสำเร็จ และพลังบวกส่องสว่างทุกด้าน',
    love: 'ความรักสดใส แต่งงาน หรือครอบครัวอบอุ่น',
    work: 'สำเร็จเป็นที่ประจักษ์ ได้รับรางวัล',
    money: 'รายได้ดี โชคลาภสูง — ช่วงทองของการเงิน',
    health: 'สุขภาพแข็งแรง พลังงานสูง',
    advice: 'ยินดีกับชัยชนะ — แบ่งปันความสุขกับคนรอบข้าง',
    dreamKeyword: 'แสงอาทิตย์',
    luckyDigits: ['19', '91', '28'],
  },
  {
    id: 20, number: 20, nameEn: 'Judgement', nameTh: 'การพิพากษา', symbol: '♀',
    element: 'ไฟ', planet: 'ดาวพลูโต',
    keywords: ['การตื่นรู้', 'การเรียกคืน', 'การตัดสิน'],
    upright: 'ตื่นรู้และตอบรับการเรียก — อดีตถูกพิพากษาและคุณเลือกก้าวต่อ',
    love: 'กลับมาหากัน หรือตัดสินใจร่วมกันอย่างจริงจัง',
    work: 'โปรโมท เรียกคืนโอกาส หรือเปลี่ยนสายอาชีพตาม vocation',
    money: 'ได้รับมรดก คืนหนี้ หรือโอกาสครั้งที่สอง',
    health: 'ฟื้นหายจากโรคเรื้อรัง',
    advice: 'ฟังเสียงเรียกจากภายใน — มันไม่ผิด',
    dreamKeyword: 'แตร',
    luckyDigits: ['20', '02', '47'],
  },
  {
    id: 21, number: 21, nameEn: 'The World', nameTh: 'โลก', symbol: '◎',
    element: 'ดิน', planet: 'ดาวเสาร์',
    keywords: ['ความสมบูรณ์', 'บทสรุป', 'ความสำเร็จ'],
    upright: 'จบวัฏจักรด้วยความสมบูรณ์ — บรรลุเป้าหมายและพร้อมเริ่มรอบใหม่',
    love: 'ความสัมพันธ์สมบูรณ์ แต่งงาน หรือครอบครัวครบ',
    work: 'สำเร็จโปรเจกต์ใหญ่ ได้รับการยอมรับระดับโลก',
    money: 'มั่งคั่ง รายได้ครบวงจร',
    health: 'สุขภาพสมบูรณ์ กายและใจเป็นหนึ่ง',
    advice: 'เฉลิมฉลอง — คุณมาถึงจุดนี้ด้วยตัวเอง',
    dreamKeyword: 'โลก',
    luckyDigits: ['21', '12', '78'],
  },
];

export function getCardById(id) {
  return MAJOR_ARCANA.find((c) => c.id === id) ?? null;
}
